import {get, identity, mapValues, orderBy, pickBy} from "lodash"

class TemplateManager {
  constructor(templateConfig) {
    this.config = templateConfig
  }

  getBlocksForPosition(position) {
    // _.pickBy(object, _.identity) is used to filter out falsy values
    return pickBy(
      mapValues(this.config, el => {
        // if position defined in block is the requested position, return the element
        // if requested position is body, additionally return the element if no position is defined
        if ((get(el, 'position') === position)) {
          return el
        }
      }),
      identity
    )
  }

  header() {
    return orderBy(this.getBlocksForPosition('header'), 'sort')
  }

  append() {
    return orderBy(this.getBlocksForPosition('append'), 'sort')
  }

  body() {
    return orderBy(this.getBlocksForPosition('body'), 'sort')
  }

  footer() {
    return orderBy(this.getBlocksForPosition('footer'), 'sort')
  }

  table() {
    return this.config.productData
  }

  figures() {
    return this.config.figures
  }

  payback() {
    return this.config.payback
  }

  futureEvents() {
    return get(this.config, 'futureEvents', [])
  }

  pastEvents() {
    return get(this.config, 'pastEvents', [])
  }
}

export default TemplateManager



// WEBPACK FOOTER //
// ./src/service/TemplateManager.js